import React from "react";
import {
  Users,
  FileText,
  Briefcase,
  Clock,
  AlertTriangle,
  RefreshCw,
} from "lucide-react";
import StatCard from "../../shared/components/StatCard";

const ICON_MAP = {
  Users,
  FileText,
  Briefcase,
  Clock,
  AlertTriangle,
  RefreshCw,
};

const DashboardStatCards = ({ stats = {} }) => {
  const cards = [
    {
      key: "totalEmployees",
      title: "Total Employees",
      value: stats.totalEmployees ?? 1248,
      icon: Users,
      iconColor: "text-white",
      iconBg: "bg-blue-600",
      trend: "↑ +18 this month",
      trendType: "positive",
    },
    {
      key: "contractEmployees",
      title: "Contract Based Employees",
      value: stats.contractEmployees ?? 284,
      icon: FileText,
      iconColor: "text-white",
      iconBg: "bg-emerald-600",
      trend: "22.8% of total",
      trendType: "positive",
    },
    {
      key: "employmentTypes",
      title: "Employment Types",
      value: stats.employmentTypes ?? 12,
      icon: Briefcase,
      iconColor: "text-white",
      iconBg: "bg-purple-600",
      description: "12 configured",
    },
    {
      key: "workSchedules",
      title: "Work Schedules",
      value: stats.workSchedules ?? 24,
      icon: Clock,
      iconColor: "text-white",
      iconBg: "bg-sky-500",
      description: "24 active templates",
    },
    {
      key: "contractsExpiring",
      title: "Contracts Expiring",
      value: stats.contractsExpiring ?? 18,
      icon: AlertTriangle,
      iconColor: "text-white",
      iconBg: "bg-amber-500",
      trend: "Next 30 days",
      trendType: "negative",
    },
    {
      key: "employmentChanges",
      title: "Employment Changes",
      value: stats.employmentChanges ?? 46,
      icon: RefreshCw,
      iconColor: "text-white",
      iconBg: "bg-teal-600",
      description: "46 this month",
    },
  ];

  return (
    <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 xl:grid-cols-6">
      {cards.map((card) => (
        <StatCard
          key={card.key}
          title={card.title}
          value={card.value}
          icon={card.icon}
          iconColor={card.iconColor}
          iconBg={card.iconBg}
          trend={card.trend}
          trendType={card.trendType}
          description={card.description}
        />
      ))}
    </div>
  );
};

export default DashboardStatCards;
